import React from 'react';
import {
  COUNTRY_OTHER,
  countryFromSelect,
  countryNameInputValue,
  countrySelectValue
} from '../constants/formOptions';

export default function BirthCountryFields({ options, value, onChange }) {
  const selectValue = countrySelectValue(value);
  const showName = selectValue === COUNTRY_OTHER;

  return (
    <>
      <div className="form-field">
        <label className="form-label">Place of Birth - Country</label>
        <select
          className="form-input"
          value={selectValue}
          onChange={(e) => onChange(countryFromSelect(e.target.value, value))}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
      {showName && (
        <div className="form-field">
          <label className="form-label">Country name <span className="required">*</span></label>
          <input
            type="text"
            className="form-input"
            value={countryNameInputValue(value)}
            onChange={(e) => onChange(e.target.value === '' ? COUNTRY_OTHER : e.target.value)}
            maxLength={50}
            required
          />
        </div>
      )}
    </>
  );
}
